import React from "react";
import { CommentGet } from "../../Models/Comment";
import StockCommentListItem from "../StockCommentListItem/StockCommentListItem";

type Props = {
  comments: CommentGet[];
  onDelete: (id: number) => void;
};

const StockCommentList = ({ comments, onDelete }: Props) => {
  if (!comments || comments.length === 0) {
    return <p className="pl-5">No comments yet.</p>;
  }

  return (
    <>
      {comments.map((comment, i) => (
        <StockCommentListItem
          key={(comment as any).id ?? i}
          comment={comment}
          onDelete={onDelete}
        />
      ))}
    </>
  );
};

export default StockCommentList;
